import theme, { colors } from '@globals/themes/defaultTheme'
import { onActive, onFocus, onHover } from '@globals/themes/themeConstants'
import { useTrialBannerHeight } from '@globals/useTrialBannerStore'
import { SxProps } from '@mui/material/styles'
import { FC, SetStateAction, useState } from 'react'
import NotificationsPopover from './DesktopNotificationsPopover'
import InAppNotificationsButton from './InAppNotificationsButton'

const getButtonStyle = (trialBannerHeight: number): SxProps => ({
  p: 1,
  position: 'fixed',
  width: 36,
  height: 36,
  boxShadow: colors.boxShadow,
  borderRadius: 100,
  [onHover]: {
    borderRadius: 100,
  },
  [onFocus]: {
    borderRadius: 100,
  },
  [onActive]: {
    borderRadius: 100,
  },
  right: 24,
  top: trialBannerHeight + 8,
})

const getBadgeStyle = (trialBannerHeight: number): SxProps => ({
  '& .MuiBadge-badge': {
    backgroundColor: colors.coralPrimary,
  },
  position: 'fixed',
  right: 36,
  top: trialBannerHeight + 24,
  zIndex: theme.zIndex.appBar + 1,
})

const InAppNotifications: FC = () => {
  const { trialBannerHeight } = useTrialBannerHeight()
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null)

  const handleOpenNotifications = (event: {
    currentTarget: SetStateAction<HTMLButtonElement | null>
  }) => {
    setAnchorEl(event.currentTarget)
  }

  const handleCloseNotifications = () => {
    setAnchorEl(null)
  }

  const open = Boolean(anchorEl)
  const id = open ? 'inAppNotificationsPopover' : undefined

  return (
    <>
      <InAppNotificationsButton
        badgeStyle={getBadgeStyle(trialBannerHeight)}
        buttonStyle={getButtonStyle(trialBannerHeight)}
        onClick={handleOpenNotifications}
      />
      <NotificationsPopover
        id={id}
        anchorEl={anchorEl}
        open={open}
        onClose={handleCloseNotifications}
      />
    </>
  )
}

export default InAppNotifications
